import { useState } from 'react'
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Typography, Alert, Box,
} from '@mui/material'
import { Lock, Warning } from '@mui/icons-material'
import StatusBadge from '../common/StatusBadge'

export default function ApprovalDialog({
  open,
  onClose,
  onApprove,
  scenario,
  currentApprovedPlan,
}) {
  const [rationale, setRationale] = useState('')

  const canApprove = rationale.trim().length >= 10

  const handleApprove = () => {
    if (!canApprove) return
    onApprove({ scenarioId: scenario?.id, rationale: rationale.trim() })
    setRationale('')
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Lock color="primary" />
        Promote Scenario to Approved Plan
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, pt: '16px !important' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body1">
            Promoting:
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {scenario?.name}
          </Typography>
          <StatusBadge status="ACTIVE" />
        </Box>

        <Alert severity="warning" icon={<Warning />}>
          <Typography variant="body2">
            This will promote <strong>{scenario?.name}</strong> to the new approved plan.
            The current approved plan
            {currentApprovedPlan && <strong> &ldquo;{currentApprovedPlan.name}&rdquo;</strong>}
            {' '}will be archived and marked as read-only.
          </Typography>
        </Alert>

        <TextField
          label="Approval Rationale"
          value={rationale}
          onChange={(e) => setRationale(e.target.value)}
          fullWidth
          multiline
          rows={4}
          required
          placeholder="Explain why this scenario should become the approved plan (min 10 characters)..."
          helperText={
            rationale.length > 0 && rationale.trim().length < 10
              ? 'Rationale must be at least 10 characters'
              : 'Required for audit trail'
          }
          error={rationale.length > 0 && rationale.trim().length < 10}
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleApprove}
          disabled={!canApprove}
          startIcon={<Lock />}
        >
          Approve &amp; Promote
        </Button>
      </DialogActions>
    </Dialog>
  )
}
